import { type SerializableRecord } from '@post-office/serializable-record';

import { type State } from './types';
import { useData } from './useData';

export const useInitialData = <I extends SerializableRecord>(
	initialData: Promise<Response>,
): State<I> =>
	useData(initialData, {
		analytics: {
			name: 'initialData',
		},
	});
